import { render, staticRenderFns } from "./zb_prop.vue?vue&type=template&id=08b9c8d6&scoped=true"
import script from "./zb_prop.vue?vue&type=script&lang=ts"
export * from "./zb_prop.vue?vue&type=script&lang=ts"
import style0 from "./zb_prop.vue?vue&type=style&index=0&id=08b9c8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b9c8d6",
  null
  
)

export default component.exports